import { CdkMenu, CdkMenuTrigger } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import {
  MdwDateTimePicker,
  MdwDateTimePickerCard,
  repositionCdkMenuTrigger,
} from '@spaces-ui/meadow/components/date-time';
import { Time } from '@spaces-ui/utils';

import { Sample } from '../../components';

@Component({
  selector: 'app-date-time-pickers',
  templateUrl: './date-time-pickers.html',
  styleUrls: ['./date-time-pickers.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    Sample,
    MdwDateTimePicker,
    MdwDateTimePickerCard,
    CdkMenu,
    CdkMenuTrigger,
    MdwButton,
  ],
})
export class DateTimePickers {
  public value = signal<Date | undefined>(new Date());

  // Inline card example
  public inlineDate = signal<Date | null>(null);
  public inlineTime = signal<Time | null>(null);

  // Menu-hosted card example
  public menuDate = signal<Date | null>(null);
  public menuTime = signal<Time | null>(null);

  protected repositionCdkMenuTrigger = repositionCdkMenuTrigger;
}
